import { RouterProvider } from '@tanstack/react-router'

import { router } from '@/app/providers/router/router'

export function AppRouter() {
  return <RouterProvider router={router} />
}
